import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack, FDTitleText, ConfirmationDialog,
} from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useMountedGuard from 'Hooks/useMountedGuard';

const PlanningVersionUpgradeResponseLayout = ({
  refreshCollection,
}) => {
  const { onSubmit } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { loadHousehold } = useSimpleHousehold();
  const { doWithMountedGuard } = useMountedGuard();

  const [showConfirmDialog, _setShowConfirmDialog] = React.useState(false);
  const [loading, _setLoading] = React.useState(false);
  const setShowConfirmDialog = doWithMountedGuard(_setShowConfirmDialog);
  const setLoading = doWithMountedGuard(_setLoading);

  const handleChange = async () => {
    try {
      // Submit the change
      await onSubmit();

      // On successful submission, refresh the collection and household
      await refreshCollection();
      await loadHousehold();
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Error saving planning version response');
      }
    }
  };


  return (
    <FDStack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
      <FDTitleText value={'Response'} />
      <MetaField
        attr={'response'}
        onChange={() => setShowConfirmDialog(true)}
      />
      <ConfirmationDialog
        open={showConfirmDialog}
        onConfirm={async () => {
          try {
            setLoading(true);

            await handleChange();

            setLoading(false);
            setShowConfirmDialog(false);
          } catch (err) {
            setLoading(false);
            setShowConfirmDialog(false);
            throw err;
          }
        }}
        loading={loading}
        onClose={() => setShowConfirmDialog(false)}
        confirmLabel={'Confirm Change'}
        title={'Confirm Planning Version Change'}
        message={'If you are selecting "opt-in", "confirm change" will (1) move the member to the new journey, (2) cancel any upcoming planning meetings (this cannot be undone), and (3) prevent this member from scheduling ad-hoc meeting by themselves. If you are moving away from "opt-in", this will allow this member to ad-hoc schedule meetings again. If you select "cancel", nothing will change.'}
      />
    </FDStack>
  );
};

PlanningVersionUpgradeResponseLayout.propTypes = {
  refreshCollection: PropTypes.func.isRequired,
};

export default PlanningVersionUpgradeResponseLayout;
